import { ArrowRight } from "iconsax-react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { BrowseToAllJob, LatestJobOpenings } from "../../../constants";
import { LatestJobOpeningsContent } from "../../../data/demo/JobDemo2";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { routes } from "../../../routers/routes";
import JobProductBox3 from "../../commonComponents/productBox/JobProductBox3";
import CommonHeader from "../common/CommonHeader";

const JobOpenings = () => {
  const { productItem } = useAppSelector((state) => state.product);
  return (
    <section className="job-box-section section-b-space">
      <Container>
        <CommonHeader title={LatestJobOpenings} content={LatestJobOpeningsContent} headClass="title-style-4" />
        <Row className="gy-4">
          {productItem
            .filter((e) => [17, 20, 25, 27, 28].includes(e.id))
            .map((job, index) => (
              <Col xxl="4" lg="6" data-aos="fade-up" data-aos-duration={200 * (index + 1)} key={index}>
                <JobProductBox3 data={job} />
              </Col>
            ))}
          <Col xxl="4" lg="6" data-aos="fade-up" data-aos-duration={1200}>
            <div className="job-box dark-job-box">
              <span className="border-bg" />
              <div className="see-all-box">
                <h2>135+</h2>
                <Link to={routes.Job.Grid.JobLeftSidebar}>
                  {BrowseToAllJob}
                  <ArrowRight className="iconsax" />
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default JobOpenings;
